import AirtableTable from "../AirtableTable";
import { Message } from "../models";
import { airtableFields, airtableTables } from "../schema";

export const messageFieldIds = airtableFields.messages;

export class MessagesTable extends AirtableTable<Message> {
  constructor(instance: any) {
    super(instance, airtableTables.messages);

    this.fields = [
      messageFieldIds.id,
      messageFieldIds.subject,
      messageFieldIds.body,
      messageFieldIds.liveDate,
      messageFieldIds.teacherRecipient,
      messageFieldIds.status,
      messageFieldIds.sentAt,
      messageFieldIds.readAt,
      messageFieldIds.requiresAction,
      messageFieldIds.actionUrl,
      messageFieldIds.actionUrlText,
      messageFieldIds.isActive
    ]
  }

  getItemsForRecipientEmail = (recipientEmail: string, limit?: number) => {
    return this.getActiveForRecipientEmail(recipientEmail)
      .then((items) => limit ? items.slice(0, limit) : items);
  }

  getUnreadForRecipientEmail = (recipientEmail: string) => {
    return this.getActiveForRecipientEmail(recipientEmail)
      .then((items: any[]) => items.filter((item) => item[messageFieldIds.status] === "Unread"));
  }

  private getActiveForRecipientEmail = async (recipientEmail: string) => {
    const email = recipientEmail.trim().toUpperCase();
    const now = new Date();
    const items = await this.list({ sort: [{ field: messageFieldIds.sentAt, direction: "desc" }] });
    return (items as any[]).filter((item) => {
      const recipients = Array.isArray(item[messageFieldIds.teacherRecipient])
        ? item[messageFieldIds.teacherRecipient] : [item[messageFieldIds.teacherRecipient]];
      const liveDate = item[messageFieldIds.liveDate];
      return recipients.some((value: any) => String(value).toUpperCase().includes(email))
        && Boolean(item[messageFieldIds.isActive])
        && (!liveDate || new Date(liveDate) <= now)
        && item[messageFieldIds.status] !== "Archived";
    });
  };
}
